module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/indi-store/kiosks/kiosks.component.css
// module id = ./src/app/indi-store/kiosks/kiosks.component.css
// module chunks = main